import {gatewayUrl} from "config";
import axiosInstance from "utils/axios-request";
import {IActiveInsuranceList} from "InsuranceV2/ActiveInsurances";
import {notifyDownload} from "utils/android";
import {downloadPdfFromBase64} from "utils/download";
import {isWebview} from "utils";

interface IRiskcovryLinkResponse {
    link: string;
    oldActiveInsurances: IActiveInsuranceList[];
}

export interface IResponse {
    preSignedUrl: string;
}

export const getRiskcovryLink = async (): Promise<IRiskcovryLinkResponse> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/insurance-gateway/riskcovry-link`,
        method: "get",
    });
    return response.data;
};

export const downloadPdfFromPreSignedUrl = (preSignedUrl: string) => {
    return fetch(preSignedUrl).then((resp) => {
        resp.text().then((bs64data) => {
            if (isWebview()) {
                notifyDownload("insurance_policy", bs64data, null, "application/pdf");
            } else {
                downloadPdfFromBase64(bs64data, "insurance_policy");
            }
        });
    });
};

export const getPreSignedUrl = async (orderId: string): Promise<IResponse> => {
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/insurance-gateway/policy`,
        method: "get",
        params: {
            orderId,
        },
    });
    return res.data;
};
